import { render, staticRenderFns } from "./CaseClosingWizard.vue?vue&type=template&id=4e9e5128&"
import script from "./CaseClosingWizard.vue?vue&type=script&lang=js&"
export * from "./CaseClosingWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports